import request from "umi-request";
import { APIRequest } from "./helpers/requests";
import { API } from "../config";

// services
import { authService } from "./ServiceAuth";

/*
 * Service functions
 */
export const companyService = {
    getCompanyInformation,
    updateCompanyInformation,
    getCoachNetwork,
    getBankAccountByID,
    createBankAccount,
    updateBankAccount,
};

async function getCompanyInformation(actAsUser = null) {
    let data;
    // create Async - Await request to get all active categories
    let accessToken = await authService.getAccessToken();
    data = await request(API.GET_COMPANY, {
        method: "get",
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return [];
        });

    return data;
}

async function getCoachNetwork() {
    let data;
    // create Async - Await request to get all active categories
    let accessToken = await authService.getAccessToken();
    data = await request(API.GET_NETWORK, {
        method: "get",
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return [];
        });

    return data;
}

async function updateCompanyInformation(data, actAsUser = null) {
    let updated;
    let accessToken = await authService.getAccessToken();
    updated = await request(API.UPDATE_COMPANY, {
        method: "put",
        data: data,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        }
    })
        .then(function (response) {
            return true;
        })
        .catch(function (error) {
            return false;
        });

    return updated;
}

async function getBankAccountByID(id, actAsUser = null) {
    return await APIRequest({
        url: API.BANK_ACCOUNT + id,
        method: 'GET',
        private: true,
        headers: {
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    });
}

async function createBankAccount(data, actAsUser = null) {
    return await APIRequest({
        url: API.BANK_ACCOUNT,
        method: 'POST',
        data: data,
        private: true,
        headers: {
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    });
}

async function updateBankAccount(data, id, actAsUser = null) {
    return await APIRequest({
        url: API.BANK_ACCOUNT + id,
        method: 'PUT',
        data: data,
        private: true,
        headers: {
            ...(actAsUser && { 'X-Acting-As': actAsUser }),
        },
    });
}
